// extracted by mini-css-extract-plugin
export var gradient = "roundedButton-module--gradient--34QDK";
export var white = "roundedButton-module--white--IaDa7";